import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import ErrorBoundary from './ErrorBoundary'
import ChannelGate from './components/ChannelGate'
import { ApolloProvider } from '@apollo/client/react'
import client from './apolloClient'
import { Toaster } from 'sonner'
import { BrowserRouter } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import { registerSW } from 'virtual:pwa-register'

registerSW({ immediate: true })

const container = document.getElementById('root')
if (!container) throw new Error('Root element not found')

const root = ReactDOM.createRoot(container)

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <ApolloProvider client={client}>
            <ChannelGate>
              <Toaster />
              <App />
            </ChannelGate>
          </ApolloProvider>
        </BrowserRouter>
      </I18nextProvider>
    </ErrorBoundary>
  </React.StrictMode>
)
